import SwitchesImage from "../../assets/images/switches.svg";
import SecureFileImage from "../../assets/images/secure_file.svg";
import PendingApprovalImage from "../../assets/images/pending_approval.svg";
import AnnotationsImage from "../../assets/images/annotations.svg";
import { hide, unhide } from "../../utils";
import { ElemID } from "../editor/constants";
import { EventBus, Events } from "../eventBus";

const image = document.getElementById("pdf-rejected-image");
const pdfRejectedComponent = document.getElementById(
  ElemID.PDF_REJECTED_COMPONENT,
);

const rejectionReasons = {
  password: {
    imgSrc: SecureFileImage,
    imgAlt: "Illustration of files with a lock on it",
    imgWidth: 200,
    descriptionElement: document.getElementById("rejected-because-password"),
  },
  widgets: {
    imgSrc: SwitchesImage,
    imgAlt: "Illustration of person standing next to 3 large toggle buttons",
    imgWidth: 200,
    descriptionElement: document.getElementById("rejected-because-widgets"),
  },
  corrupted: {
    imgSrc: PendingApprovalImage,
    imgAlt: "Illustration of files with a question mark on it",
    imgWidth: 200,
    descriptionElement: document.getElementById("rejected-because-corrupted"),
  },
  template: {
    imgSrc: AnnotationsImage,
    imgAlt: "Illustration of a person looking at a file containing annotations",
    imgWidth: 200,
    descriptionElement: document.getElementById("rejected-because-template"),
  },
};

const defaultReason = rejectionReasons["corrupted"];

const textContainer = document.getElementById("pdf-rejected-text-container");
const editAnotherButton = document.getElementById(
  "pdf-rejected-edit-another-button",
);

function initPdfRejected(reason) {
  editAnotherButton.addEventListener("click", function () {
    window.location.reload();
  });

  let reasonSpec = rejectionReasons[reason] || defaultReason;
  image.src = reasonSpec.imgSrc;
  image.alt = reasonSpec.imgAlt;
  image.style.width = reasonSpec.imgWidth + "px";

  textContainer.querySelectorAll(".rejected-reason").forEach(hide);
  unhide(reasonSpec.descriptionElement);
  unhide(pdfRejectedComponent);
}

EventBus.subscribe(Events.PDF_REJECTED, function (payload) {
  initPdfRejected(payload.reason);
});
